import IconDashboard from 'Assets/images/commons/dashboard-white.svg';
import IconDashboardActive from 'Assets/images/commons/dashboard_active.svg';
import IconTeleconsult from 'Assets/images/commons/teleconsult-white.svg';
import IconTeleconsultActive from 'Assets/images/commons/teleconsult_active.svg';
import IconCalender from 'Assets/images/commons/calendar-white.svg';
import IconCalenderActive from 'Assets/images/commons/calendar_active.svg';
import IconPrescription from 'Assets/images/commons/prescription-white.svg';
import IconPrescriptionActive from 'Assets/images/commons/prescription_active.svg';
import IconLabResult from 'Assets/images/commons/lab_result-white.svg';
import IconLabResultActive from 'Assets/images/commons/lab_result_active.svg';
import IconPatientData from 'Assets/images/commons/patient_data-white.svg';
import IconPatientDataActive from 'Assets/images/commons/patient_data_active.svg';
import IconSetting from 'Assets/images/commons/setting-white.svg';
import IconSettingActive from 'Assets/images/commons/setting_active.svg';
import IconCompany from 'Assets/images/commons/company-white.svg';
import IconCompanyActive from 'Assets/images/commons/company_active.svg';
import IconPatients from 'Assets/images/commons/patients.svg';

export default [
  {
    icon: IconDashboard,
    iconActive: IconDashboardActive,
    name: 'home',
    id: 'menu_home',
    link: '/home',
  },
  {
    icon: 'home',
    iconActive: 'home',
    name: 'accountManagement',
    id: 'menu_accountManagement',
    link: '/account-management',
  },
  {
    icon: IconTeleconsult,
    iconActive: IconTeleconsultActive,
    name: 'web-chat',
    id: 'menu_webChat',
    link: '/web-chat',
  },
  {
    icon: IconCompany,
    iconActive: IconCompanyActive,
    name: 'appointments',
    id: 'menu_appointments',
    link: '/appointments',
  },
  {
    icon: IconCalender,
    iconActive: IconCalenderActive,
    name: 'working-calendar',
    id: 'menu_workingCalendar',
    link: '/working-calendar',
  },
  {
    icon: IconLabResult,
    iconActive: IconLabResultActive,
    name: 'lab',
    id: 'menu_labResults',
    link: '/lab-results',
  },
  {
    icon: 'address book',
    iconActive: 'address book',
    name: 'emr',
    id: 'menu_emr',
    link: '/emr',
  },
  {
    icon: IconPatientData,
    iconActive: IconPatientDataActive,
    name: 'bpdata',
    id: 'menu_bpdata',
    link: '/bp-data',
  },
  {
    icon: IconPrescription,
    iconActive: IconPrescriptionActive,
    name: 'prescriptions',
    id: 'menu_prescription',
    link: '/prescriptions',
  },
  // {
  //   icon: IconPatients,
  //   iconActive: IconPatients,
  //   name: 'patients',
  //   id: 'menu_patients',
  //   link: '/patients',
  // },
  // {
  //   icon: IconPrescription,
  //   iconActive: IconPrescriptionActive,
  //   name: 'management',
  //   id: 'menu_management',
  //   link: '/management',
  //   children: [
  //     {
  //       name: 'user',
  //       id: 'menu_management_users',
  //       link: '/management/users',
  //     },
  //     {
  //       name: 'role',
  //       id: 'menu_management_roles',
  //       link: '/management/roles',
  //     },
  //     {
  //       name: 'permission',
  //       id: 'menu_management_permissions',
  //       link: '/management/permissions',
  //     },
  //     {
  //       name: 'clinic',
  //       id: 'menu_management_clinic',
  //       link: '/management/clinic',
  //     },
  //   ],
  // },
  {
    icon: IconSetting,
    iconActive: IconSettingActive,
    name: 'settings',
    id: 'menu_settings',
    link: '/settings',
  },
  {
    icon: 'sign out',
    iconActive: 'sign out',
    name: 'appointmentLogout',
    id: 'menu_logout',
    link: '/logout',
  },
];
